/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Education_DegreeInputs */

const en_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B.Sc. in Computer Science & Engineering`)
};

const ar_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بكالوريوس العلوم في علوم وهندسة الحاسوب`)
};

const bn_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কম্পিউটার সায়েন্স ও ইঞ্জিনিয়ারিংয়ে বি.এসসি`)
};

const de_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B.Sc. in Informatik und Ingenieurwesen`)
};

const es_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B.Sc. en Ciencias de la Computación e Ingeniería`)
};

const fr_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`B.Sc. en informatique et ingénierie`)
};

const pt_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bacharel em Ciências em Ciência da Computação e Engenharia`)
};

const zh_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理学学士计算机科学与工程博士`)
};

const tr_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisans Bilgisayar Bilimi ve Mühendisliği Yüksek Lisansı`)
};

const ru_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бакалавр наук. в области компьютерных наук и инженерии`)
};

const pl_education_degree = /** @type {(inputs: Education_DegreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`licencjat w informatyce i inżynierii`)
};

/**
* | output |
* | --- |
* | "B.Sc. in Computer Science & Engineering" |
*
* @param {Education_DegreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const education_degree = /** @type {((inputs?: Education_DegreeInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Education_DegreeInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_education_degree(inputs)
	if (locale === "bn") return bn_education_degree(inputs)
	if (locale === "de") return de_education_degree(inputs)
	if (locale === "es") return es_education_degree(inputs)
	if (locale === "fr") return fr_education_degree(inputs)
	if (locale === "pt") return pt_education_degree(inputs)
	if (locale === "zh") return zh_education_degree(inputs)
	if (locale === "tr") return tr_education_degree(inputs)
	if (locale === "ru") return ru_education_degree(inputs)
	if (locale === "pl") return pl_education_degree(inputs)
	return en_education_degree(inputs)
});